import React from 'react';

const Footer = () => {
    return (
        <div className='background py-4'>
               <p className=' text-white'>Design & Developed by Foyjur Rahman</p>
        </div>
    );
};

export default Footer;